import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

export default function ToggleStatusDialog(props: {
  handleCloseDialog: any;
  handleConfirm: any;
  openDialog: any;
  name: string;
  deactivating: Boolean;
  activating: Boolean;
}) {
  const { handleCloseDialog, handleConfirm, openDialog, name, deactivating, activating } = props;

  return (
    <Dialog
      sx={{
        width: { xs: "23em", sm: "27em", md: "30em", xl: "100%" },
        margin: "auto",
      }}
      open={openDialog}
      onClose={handleCloseDialog}
      fullWidth
    >      
      {deactivating && (
        <>
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', mt: 2, ml: 2 }} variant={"h3"}> Deactivate {name}
          </DialogTitle>
          <DialogContent sx={{ mr: 2, ml: 2 }}>
            <DialogContentText variant={"h5"} paragraph>
              Are you sure you want to deactivate this {name}?
              Deactivating the inventory will disable its functionality, and it may currently contain items.<br></br>     
              You can still reactivate it later in the 'Deactivated Inventories' section if needed.
            </DialogContentText>
          </DialogContent>
        </>
      )}      
      {activating && (
        <>
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', mt: 2, ml: 2 }} variant={"h3"}> Activate {name}
          </DialogTitle>
          <DialogContent sx={{ mr: 2, ml: 2 }}>
            <DialogContentText variant={"h5"} paragraph>
              Are you sure you want to Activate this {name}?              
            </DialogContentText>
          </DialogContent>
        </>
      )}      
      <DialogActions sx={{ mb: 2, mr: 2}}>
        <Button onClick={handleCloseDialog}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} autoFocus variant="outlined" color="error">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
